export const NEW_COMMENT_STORAGE_KEY = `CRM:Events:NewCommentState`;
export const EDIT_COMMENT_STORAGE_KEY = `CRM:Events:EditCommentState`;
export const REPLY_COMMENT_STORAGE_KEY = `CRM:Events:ReplyCommentState`;
export const getNewCommentStorageKey = ({
  objectType,
  objectId
}) => `${NEW_COMMENT_STORAGE_KEY}:${objectType}-${objectId}`;
export const getEditCommentStorageKey = ({
  objectType,
  objectId,
  commentId
}) => `${EDIT_COMMENT_STORAGE_KEY}:${objectType}-${objectId}-${commentId}`;
export const getReplyCommentStorageKey = ({
  objectType,
  objectId,
  parentCommentId
}) => `${REPLY_COMMENT_STORAGE_KEY}:${objectType}-${objectId}-${parentCommentId}`;